import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import MainLay from "./pages/MainLay";
import auth from "./routers/auth";
import "./App.css";
import { Spin, Button, Result } from "antd";


const Login = lazy(() => import("./pages/login"));

const HomePageV3=lazy(()=>import('./pages/HomeV3'))

/* Model Training */
const ModelInterPage = lazy(() => import("./pages/GSBreeding/ModelIntr"));
const GSModelPage = lazy(() => import("./pages/GSBreeding/GSModel/"));
const PredictPage = lazy(() => import("./pages/GSBreeding/Predict"));
const ParentPage = lazy(() => import("./pages/GSBreeding/Parent"));
const ABLUPPage = lazy(() =>
  import("./pages/GSBreeding/GSPlus").then((module) => ({ default: module.ABLUPPage }))
);
const SSGBLUPPage = lazy(() =>
  import("./pages/GSBreeding/GSPlus").then((module) => ({ default: module.SSGBLUPPage }))
);
const MatingPage = lazy(() =>
  import("./pages/GSBreeding/GSPlus").then((module) => ({ default: module.MatingPage }))
);

const GsDetail = lazy(() => import("./pages/GSBreeding/GSModel/GsModelDetail"));
const PreditDetail = lazy(() =>
  import("./pages/GSBreeding/Predict/PredictDetail")
);
const ParentDetail = lazy(() =>
  import("./pages/GSBreeding/Parent/ParentDetail")
);
/* Breed Application */
const VarietyBreedPage = lazy(() => import("./pages/Breeding/VarietyBreed"));
const CoreGermBreenPage = lazy(() => import("./pages/Breeding/CoreGerm"));
const KinshipcPage = lazy(() => import("./pages/Breeding/Kinshipc"));
const MolecularPage = lazy(() => import("./pages/Breeding/Molecular"));

const VarIetyDetailCom = lazy(() =>
  import("./pages/Breeding/VarietyBreed/VarietyDetail")
);
const CoreCollDetailCom = lazy(() =>
  import("./pages/Breeding/CoreGerm/CoreCollDetail")
);
const KinShipcDetail = lazy(() =>
  import("./pages/Breeding/Kinshipc/KinshipcDetail")
);

const MolecularDetail = lazy(() =>
  import("./pages/Breeding/Molecular/MolecularDetail")
);

const AccountPages = lazy(() => import("./pages/Account"));



const Introduction = lazy(() => import("./pages/Pheno/Introduction"));
const PlantPheno = lazy(() => import("./pages/Pheno/Plant"));
const AnimalPheno = lazy(() => import("./pages/Pheno/Animal"));
const PhenoTypePages = lazy(() => import("./pages/Pheno/Phenotypic"));
const PhenoTypeDetail = lazy(() =>
  import("./pages/Pheno/Phenotypic/PhenotypeDetail")
);

const Datamanagement = lazy(() => import("./pages/Data/Datamanage"));
const DataUpload = lazy(() => import("./pages/Data/DataUpload"));
const HelpV2 = lazy(() => import("./pages/Helpv2"));

const MessagePages = lazy(() => import("./pages/Message_consultation"));
const MFMGP=lazy(()=>import('./pages/TaskList2'))
const GeoMapPage=lazy(()=>import('./pages/Pdf/GaodeMap'))
function App() {
  const navigate = useNavigate();
  return (
    <Suspense
      fallback={
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin />
          <span style={{ margin: "0 10px" }}>Loading...</span>
        </div>
      }
    >
      <Routes>
        <Route path="/Breeding" element={React.createElement(auth(MainLay))}>
          <Route path="*" element={<div>暂未开发</div>} />
          {/* 留言界面 */}
          <Route path="message" element={<MessagePages />} />
          {/* Home */}
          <Route path="home" element={<HomePageV3 />} />
          {/* <Route path="homethree" element={<HomePageV3/>}/> */}
          {/* Pheno */}
          {/* 管理员登录导航 */}
          <Route path="introduction" element={<Introduction />} />
          <Route path="plant" element={<PlantPheno />} />
          <Route path="animal" element={<AnimalPheno />} />
          <Route path="phenotypic" element={<PhenoTypePages />} />
          <Route path="phenotypicdetail" element={<PhenoTypeDetail />} />
          {/* 用户登录导航 */}
          <Route path="datamanagement" element={<Datamanagement />} />
          <Route path="dataupload" element={<DataUpload />} />
          {/* Model Training */}
          <Route path="modelinter" element={<ModelInterPage />} />
          <Route path="gsmodel" element={<GSModelPage />} />
          <Route path="predict" element={<PredictPage />} />
          <Route path="parent" element={<ParentPage />} />
          <Route path="ablup" element={<ABLUPPage />} />
          <Route path="ssgblup" element={<SSGBLUPPage />} />
          <Route path="optimalmating" element={<MatingPage />} />
          <Route path="gsmodeldetail" element={<GsDetail />} />
          <Route path="preditdetail" element={<PreditDetail />} />
          <Route path="parentdetail" element={<ParentDetail />} />

          {/* Breeding Application */}
          <Route path="breedident" element={<VarietyBreedPage />} />
          <Route path="corecollection" element={<CoreGermBreenPage />} />
          <Route path="kinshipc" element={<KinshipcPage />} />
          <Route path="molecular" element={<MolecularPage />} />
          <Route path="VarIteDetail" element={<VarIetyDetailCom />} />
          <Route path="corecolldetail" element={<CoreCollDetailCom />} />
          <Route path="kinshipcdetail" element={<KinShipcDetail />} />
          <Route path="moleculardetail" element={<MolecularDetail />} />
          <Route path="account" element={<AccountPages />} />
          <Route path="help" element={<HelpV2 />} />
          <Route path="PFMGP" element={<MFMGP/>}/>
        </Route>
       
        <Route path="login" element={<Login />} />
        <Route
          path="/404"
          element={
            <Result
              status="404"
              title="404"
              subTitle="Sorry, the page you visited does not exist."
              extra={
                <Button
                  type="primary"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Back Home
                </Button>
              }
            />
          }
        />
        <Route
          path="/403"
          element={
            <Result
              status="403"
              title="403"
              subTitle="Sorry, you are not authorized to access this page."
              extra={
                <Button
                  type="primary"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Back Home
                </Button>
              }
            />
          }
        />
        <Route path="*" element={<Navigate to="/404" />} />
        <Route path="/" element={<Navigate to="/Breeding/home/" />} />
      </Routes>
    </Suspense>
  );
}

export default App;
// 1. 配置axios  基础配置
// 2. 配置  redux 基础配置
// 3. 配置路由   基础配置
// 4. 配置代理，配置后包括axios请求都不用再写域名了
// 5. 路由懒加载
// 6. 配置MainLay文件
// /admin/home/
// /admin/product/product_list
// /admin/product/product_classify
// /admin/cms/article/index
// /admin/product/add_product
